export const ACCOUNT_TYPES = [
    { id: 1, name: "Master Admin" },
    { id: 2, name: "National Account" },
    { id: 3, name: "Province Account" },
    { id: 4, name: "District Account" },
    { id: 5, name: "Municipality Account" },
];
